import { render, staticRenderFns } from "./Qq.vue?vue&type=template&id=5cdeda48&scoped=true&"
import script from "./Qq.vue?vue&type=script&lang=js&"
export * from "./Qq.vue?vue&type=script&lang=js&"
import style0 from "./Qq.vue?vue&type=style&index=0&id=5cdeda48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdeda48",
  null
  
)

export default component.exports